import { mapActions, mapGetters, mapState } from 'vuex';
import { TAB_ALL } from '@maison/helpers/search-helper';

export default {
  computed: {
    ...mapState('search', ['currentTab', 'isLoading', 'query', 'tabs']),

    ...mapGetters('search', ['totalResults']),

    hasQuery() {
      return this.query !== '';
    },

    hasResults() {
      return this.totalResults > 0;
    },

    shouldDisplayResults() {
      return !this.isLoading && this.hasResults;
    },

    shouldDisplayNoResults() {
      return this.hasQuery && !this.hasResults;
    },
  },

  methods: {
    ...mapActions('search', ['changeCurrentTab', 'setQuery', 'resultComponentIsPresent']),

    tabId(tab) {
      return `search-results-${tab}`;
    },

    tabTitle(tab) {
      return this.$t(`Search.tab.${tab}`);
    },

    tabTotal(tab) {
      return tab === TAB_ALL ? this.totalResults : this.tabs[tab].total;
    },

    componentNameForTab(tab) {
      return `SearchResultsTab${tab[0].toUpperCase()}${tab.substring(1)}`;
    },
  },
};
